module.exports = __webpack_public_path__ + "fonts/Helvetica-Bold.d13db1fe.ttf";